import { useEffectiveTenant } from '../../../hooks/useEffectiveTenant';
import { useFeatureFlags } from '../../../hooks/useFeatureFlag';
import { useGetTienePhylaxQuery } from '../../../store/api/marketplaceApi';

/**
 * Phylax para una inmobiliaria de BOOSTER (22/10/2026).
 *
 * - `esBooster`: es una inmobiliaria de Booster y la flag `phylax-marketplace` (la de Phylax
 *   para Booster) está prendida. Con eso el menú "Phylax" queda FIJO en Integraciones,
 *   tenga o no la suscripción: sin ella, la sección muestra qué incluye y cuánto sale.
 * - `tiene`: la suscripción está vigente. Recién ahí la sección es la de siempre (la misma
 *   que tiene Imperium, según el rol) y el CRM le puede pedir datos al backend.
 */
export function usePhylaxBooster() {
  const { tenantMode } = useEffectiveTenant();
  const { flags } = useFeatureFlags();
  const esBooster = tenantMode === 'booster' && flags['phylax-marketplace'] === true;
  const { data, isLoading } = useGetTienePhylaxQuery(undefined, { skip: !esBooster });
  return { esBooster, tiene: esBooster && data?.tiene === true, cargando: esBooster && isLoading };
}
